import apiConfigs from '@/services/config'

export default {
    data() {
        return {
            company: {
                data: [],
                name: '',
                selected: null,
                isFetching: false
            },
            position: {
                data: [],
                name: '',
                selected: null,
                isFetching: false
            },
            city: {
                data: [],
                name: '',
                selected: null,
                isFetching: false
            }
        }
    },
    methods: {
        getAutoCompleteService(serviceType) {
            let params = {},
                obj = null,
                responseObj = null;

            switch (serviceType) {
                case 'company':
                    obj = this.company;
                    responseObj = 'companies';
                    params = {
                        keyword: obj.name,
                        from: 0,
                        size: 20
                    }
                    break;
                case 'position':
                    obj = this.position;
                    responseObj = 'items';
                    params = {
                        keyword: obj.name,
                        pageSize: 20,
                        pageNumber: 1
                    }
                    break;
                case 'city':
                    obj = this.city;
                    responseObj = 'cities';
                    params = {
                        keyword: obj.name,
                        pageSize: 20,
                        pageNumber: 1
                    }
                    break;
            }

            if (!obj.name.length) {
                obj.data = []
                return
            }

            obj.isFetching = true

            apiConfigs.serviceWrapper(apiConfigs.serviceConfigs[serviceType], apiConfigs.serviceConfigs[serviceType].search, params)
                .then(({data}) => {
                    obj.data = []
                    responseObj = data.result[responseObj]
                    if (responseObj && responseObj.length > 0) {
                        if(serviceType === 'city') //change the property names to match the autocomplete component and delete the old properties
                        {
                            responseObj.forEach((item) => {
                                item.name = item.cityName;
                                item.id = item.cityId;
                                delete item.cityName;
                                delete item.cityId;
                            })
                        }
                            responseObj.forEach((item) => obj.data.push(item))
                    }
                    obj.isFetching = false
                })
                .catch((error) => {
                    obj.data = []
                    obj.isFetching = false
                    throw error
                })

        }
    },
    mounted(){

        // set session storage user company, position

        if (sessionStorage && sessionStorage.userCompany){
            let company = JSON.parse(sessionStorage.userCompany)
            if(company!=null)
            {
                this.$refs.companyAutocomplete.setSelected({
                    companyName: company.companyName,
                    companyId : company.companyId
                })  
            }
        
        }

        if (sessionStorage && sessionStorage.userPosition){
            let position = JSON.parse(sessionStorage.userPosition)
            this.$refs.positionAutocomplete.setSelected({
                name: position.name,
                id: position.id
            })
        }

        if (sessionStorage && sessionStorage.city){
            let city = JSON.parse(sessionStorage.city)
            this.$refs.cityAutocomplete.setSelected({
                name: city.name,
                id: city.id
            })
        }

    }
}
